import React from 'react';
import ReactQuill from 'react-quill';
import {connect} from 'react-redux';
import MediaSelectModal from '../Forms/MediaSelectModal';
import {GetFileType, mediaUrl} from '../../helpers/Helpers';
import {
    selectMediaItemsReset,
    get as getMedia,
    showSelectModal,
    hideSelectModal,
    hideUploadModal,
    refreshFalse as refreshFalseMedia,
    destroy as destroyMedia
} from '../../store/actions/media';

import GlobalFieldSelectModal from "../Forms/GlobalFieldSelectModal";

class CustomReactQuill extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            editorHtml: '',
            globalVariableModalShow: false,
            defaultMediaType: "images",
            filterMediaTypeEnabled: false,
        };

        this.onInsertGlobalVariable = this.onInsertGlobalVariable.bind(this);
        this.showMediaSelectModal = this.showMediaSelectModal.bind(this);
        this.globalVariableModalShowModal = this.globalVariableModalShowModal.bind(this);
        this.globalVariableModalHideModal = this.globalVariableModalHideModal.bind(this);


        this.modules = {
            toolbar: {
                container: [
                    [
                        {
                            'header': [false, 1, 2, 3, 4, 5, 6]
                        }
                    ],
                    [
                        'bold',
                        'italic',
                        'underline',
                        'strike',
                        'blockquote'
                    ],
                    [
                        {
                            'list': 'ordered'
                        },
                        {
                            'list': 'bullet'
                        },
                        {
                            'indent': '-1'
                        },
                        {
                            'indent': '+1'
                        }
                    ],
                    [
                        'link', 'image', 'globalVariables'
                    ],
                    [
                        'clean'
                    ],
                    [
                        {
                            'align': ''
                        }
                    ],
                    [
                        {
                            'align': 'right'
                        }
                    ],
                    [
                        {
                            'align': 'center'
                        }
                    ],
                    [
                        {
                            'align': 'justify'
                        }
                    ]
                ],
                handlers: {
                    'image': this.showMediaSelectModal,
                    'globalVariables': this.globalVariableModalShowModal,
                }
            }
        };

        this.formats = [
            'header', 'font', 'size',
            'bold', 'italic', 'underline', 'strike', 'blockquote',
            'list', 'bullet', 'indent',
            'link', 'image', 'globalVariables', 'video',
            'clean',
            'align'
        ];

        this.quillRef = [];
    }

    componentDidMount() {
        this.props.hideUploadModal();
        this.props.hideSelectModal();
    }

    showMediaSelectModal() {
        const {name} = this.props;
        this.setState({
            defaultMediaType: "images",
            filterMediaTypeEnabled:false
        });
        this.props.showSelectModal(name);
        this.props.selectMediaItemsReset();
    }

    globalVariableModalShowModal() {
        this.setState({
            globalVariableModalShow: true
        });
    }

    globalVariableModalHideModal() {
        this.setState({globalVariableModalShow: false});
    }

    onInsertGlobalVariable(name, item) {
        let editor = this.quillRef[name].getEditor();

        editor.focus();

        let range = editor.getSelection();
        let positionIndex = range.index;

        if (!positionIndex) {
            positionIndex = 1;
        }

        const textToInsert = "[" + item.id + "]";
        let delta = {
            ops: [
                {retain: positionIndex},
                {insert: textToInsert}
            ]
        };

        editor.updateContents(delta);
        positionIndex += textToInsert.length;
        editor.insertText(positionIndex, " ");
        positionIndex += 1;

    }

    onInsert(name, items) {
        let x = null;
        let fileType = "";
        let editor = this.quillRef[name].getEditor();

        editor.focus();

        let range = editor.getSelection();
        let positionIndex = range.index;

        if (!positionIndex) {
            positionIndex = 1;
        }

        for (x in items) {
            fileType = GetFileType(items[x].fileName);

            if (fileType.id === "images") {
                editor.insertEmbed(positionIndex, 'image', mediaUrl(items[x]), "user");
            } else {
                let delta = {
                    ops: [
                        {retain: positionIndex},
                        {insert: items[x].fileName, attributes: {link: mediaUrl(items[x])}}
                    ]
                };

                editor.updateContents(delta);
                positionIndex += items[x].fileName.length;
                editor.insertText(positionIndex, " ");
                positionIndex += 1;
            }
        }
    }

    render() {
        const {name, value} = this.props;
        const {globalVariableModalShow, defaultMediaType, filterMediaTypeEnabled} = this.state;

        return (
            <div>
                <ReactQuill
                    ref={(ref) => {
                        this.quillRef[name] = ref
                    }}
                    name={name}
                    theme="snow"
                    defaultValue={value}
                    modules={this.modules}
                    bounds={".quill"}
                    formats={this.formats}
                    placeholder={this.props.placeholder}
                    onChange={(value, delta, source) => {
                        this.props.onChange(value);
                    }}
                />
                <MediaSelectModal
                    name={name}
                    onInsert={(name, items) => {
                        this.onInsert(name, items);
                    }}
                    filterMediaTypeEnabled={filterMediaTypeEnabled}
                    defaultMediaType={defaultMediaType}
                />
                <GlobalFieldSelectModal
                    name={name}
                    show={globalVariableModalShow}
                    onInsert={(name, items) => {
                        this.onInsertGlobalVariable(name, items);
                    }}
                    onClose={this.globalVariableModalHideModal}
                />
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        media: state.media,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getMedia: () => dispatch(getMedia()),
        destroyMedia: (id) => dispatch(destroyMedia(id)),
        refreshFalseMedia: () => dispatch(refreshFalseMedia()),
        showSelectModal: (name) => dispatch(showSelectModal(name)),
        hideSelectModal: () => dispatch(hideSelectModal()),
        hideUploadModal: () => dispatch(hideUploadModal()),
        selectMediaItemsReset: () => dispatch(selectMediaItemsReset())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(CustomReactQuill)



// WEBPACK FOOTER //
// ./src/core/admin/components/Fields/CustomReactQuill.js